import { Injectable } from '@angular/core';
import { NavigationCancel, NavigationEnd, NavigationError, NavigationStart, Router } from '@angular/router';
import { BehaviorSubject, Observable } from 'rxjs';

@Injectable({ providedIn: 'root' })
export class NavigationLoaderService
{
    private _isLoadingSubject: BehaviorSubject<boolean> = new BehaviorSubject<boolean>(false);
    readonly isLoading$: Observable<boolean> = this._isLoadingSubject.asObservable();

    private _navigationInProgressCount: number = 0;

    constructor(private _router: Router)
    {
        this._router.events.subscribe((event) => {
            if (event instanceof NavigationStart)
            {
                this._navigationInProgressCount++;
                this._setLoading(true);
            }
            else if (event instanceof NavigationEnd || event instanceof NavigationCancel || event instanceof NavigationError)
            {
                this._navigationInProgressCount = Math.max(0, this._navigationInProgressCount - 1);
                if (this._navigationInProgressCount === 0)
                {
                    this._setLoading(false);
                }
            }
        });
    }

    private _setLoading(isLoading: boolean): void
    {
        if (this._isLoadingSubject.value !== isLoading)
        {
            this._isLoadingSubject.next(isLoading);
        }
    }
}


